"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _withStyles = _interopRequireDefault(require("../../utils/withStyles"));

var _NavigationContext = _interopRequireDefault(require("./NavigationContext"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Navigation = function Navigation(_ref) {
  var type = _ref.type,
      classes = _ref.classes,
      children = _ref.children,
      dark = _ref.dark,
      props = _objectWithoutProperties(_ref, ["type", "classes", "children", "dark"]);

  return _react["default"].createElement(_NavigationContext["default"].Provider, {
    value: type
  }, _react["default"].createElement("div", _extends({
    className: (0, _classnames["default"])(classes.root, classes[type])
  }, props), children));
};

Navigation.propTypes = {
  /** Map of rule names and generated class names */
  classes: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,

  /** Children of Navigation component */
  children: _propTypes["default"].node,

  /** Navigation can either be 'primary', 'secondary' or 'aside' */
  type: _propTypes["default"].oneOf(['primary', 'secondary', 'aside']).isRequired,

  /** Bool to apply dark background for "aside" navs with expandable menus */
  dark: _propTypes["default"].bool
};
Navigation.defaultProps = {
  children: null,
  dark: false
};

var _default = (0, _withStyles["default"])(_styles["default"])(Navigation);

exports["default"] = _default;